import API from 'services/api';

type TSendPartnerSms = {
  mobilePhone: string;
  message: string;
  autoLog: boolean;
};

export const sendPartnerSms = ({ payload }: { payload: TSendPartnerSms }) =>
  API.post('/api/partners/sendSMS', payload);
